import moment from 'moment';
import { IFoodicsLogFilters } from 'src/view/screens/FoodicsLogScreen/screens/FoodicsLog/types/foodicsLog';

export enum FOODICS_LOG_COLUMN {
  TIME = 'time',
  USER = 'user',
  ACTION = 'action',
  SYNC_DATA = 'sync_data',
  SYNC_FROM = 'sync_from',
  DAILY_SYNC = 'daily_sync',
}

export const defaultFoodicsLogFilters: IFoodicsLogFilters = {
  startDate: moment().startOf('month').unix(),
  endDate: moment().unix(),
};
